@if (chip) {
  <div
    [attr.title]="chip.label"
    [class.compact]="compact"
    [ngClass]="'tone-' + chip.tone"
    class="status-chip"
    data-testid="issue-stage-chip">{{ chip.label }}</div>
}
